import { useTranslation } from "react-i18next";
import moment from "moment";
import { useAppSelector } from "store";
import { formatTime, useTimeFormat } from "helpers/timeFormat";

const OperationsLedgerTab: React.FC = () => {
  const { t } = useTranslation();
  const timeFormat = useTimeFormat();

  const items = useAppSelector((store) => store.paymentsOperations.ledgerItems);

  const getUser = (user: any) => {
    if (!user) return "—";
    if (user.email) return user.email;
    if (user.firstName) return user.firstName;
    return "—";
  };
  return (
    <div className="operation-content-wrapper">
      <div className="inner-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>{t("account")}</th>
              <th>{t("effect")}</th>
              <th>{t("user")}</th>
              <th>{t("amount")}</th>
              <th>{t("currency")}</th>
              <th>{t("balanceAfter")}</th>
              <th>{t("created")}</th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  No ledger records
                </td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td>{item.accountLabel}</td>
                  <td>{item.effectLabel}</td>
                  <td>{getUser(item.user)}</td>
                  <td>{item.amount}</td>
                  <td>{item.currency}</td>
                  <td>{item.balanceAfter}</td>
                  <td className="date">
                    <span>{moment(item.created).format("DD.MM.YYYY")}</span>
                    <span>{formatTime(item.created, timeFormat)}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OperationsLedgerTab;
